import { isLocal, isDev } from 'config/api.config'
import { useEffect, useSelector } from 'hooks'
import Rollbar from 'rollbar'

// Chrome -92 - Cannot read property 'screenName' of undefined
// Chrome 93+ - Cannot read properties of undefined (reading 'mediaAccessType')
// Safari - undefined is not an object (evaluating 't.screenName')
const checkUndefined = message => /undefined/.test(message) && message.match(/'(?:\w+\.)?(\w+)'/)?.[1]

// Remove style instructions and simplify JSON
// %cEvent %o color:#777;font-weight:600;font-size:11px {\"type\":\"action\",\"name\":\"setWidgetState\",\"object\":{},\"arguments\":[{\"showScrollbar\":false}],\"spyReportStart\":true}
// %c action     color: #03A9F4; font-weight: bold {"type":"FETCH_ACCOUNT_SUCCESS","meta":{"url":"/app/myprofile/update"},"payload":{"crossRegistrationDestinationSite":0 ...
const message = {
  noStyles: m => m.replace(/%c\s?(\w+( state)?)\s+(%o\s)?((color|font-\w+):\s?[a-z0-9#]*;? ?)+/i, '$1 '),
  niceObjects: m =>
    m
      .replace(/"(\w+)":/gi, '$1:')
      .replace(/"/g, '\'')
      .replace(/([{}:,])(?=[\w\[{'])/g, '$1 '),
  prettify: m => message.niceObjects(message.noStyles(m)).replace(/\\/g, ''),

  isUseless: m => m.type == 'log' && /^Target {}$|^Function undefined$|^Arguments /.test(m.body.message),
}

const rollbarConfig = {
  accessToken: '78b556bc042a4ddb95ddff8b91b1f1bd',
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: isLocal ? 'local' : isDev ? 'devel' : 'prod',
  verbose: true,
  checkIgnore(/* isUncaught, args, payload */) {
    // decide if we want to ignore the error
  },
  transform(data) {
    const {
      level,
      body: { trace, telemetry },
    } = data
    if (level != 'error' || !trace?.exception?.message) {
      return
    }
    try {
      telemetry
        .filter(e => e.type == 'log' && /^%c/.test(e.body.message))
        .forEach(e => {
          e.body.message = message.prettify(e.body.message)
        })
      if (/_ERROR - \d+/.test(trace.exception.message)) {
        data.fingerprint = trace.exception.message.replace(/_ERROR - /, '-').toLowerCase()
      } else {
        const la = window.lastAction || {}
        data.body.telemetry.push({
          body: {
            message: `last ${la.type} response ${message.niceObjects(JSON.stringify(la.data || null))}`,
          },
          source: 'client',
          level: 'warning',
          type: 'log',
          timestamp_ms: telemetry.slice(-1)[0]?.timestamp_ms || +new Date(),
        })
      }
      const name = checkUndefined(trace.exception.message)
      if (name) {
        trace.exception.description = trace.exception.message
        trace.exception.message = `Undefined property access - ${name}`
        data.fingerprint = `undefined.${name}`
      }
      data.body.telemetry = telemetry.filter(e => !message.isUseless(e))
    } catch (e) {
      console.warn('Failed to prettify rollbar log')
    }
  },
}

const useLogger = () => {
  const { id, screenName, nickname, email } = useSelector(s => s.myProfile)

  useEffect(() => {
    const codeVersion = document.querySelector('script[src*="main.js"]')?.src.replace(/.*\?v=/, '')

    window.rb = new Rollbar({
      ...rollbarConfig,
      codeVersion,
      payload: {
        person: { id, email, username: `${email} | ${nickname} | ${screenName}` },
      },
    })
  }, [])
}

export { useLogger as default, useLogger }
